import { render, staticRenderFns } from "./category-events-list.vue?vue&type=template&id=77b54b8a&"
import script from "./category-events-list.vue?vue&type=script&lang=js&"
export * from "./category-events-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports